import Swiper from 'swiper/bundle';

if ($('.js-sliderPartners').length > 0) {
  $(window).on('load', function() {
    let sliderPartners = new Swiper('.js-sliderPartners .swiper-container', {
      slidesPerView: "auto",
      // spaceBetween: 8,
      // slidesOffsetAfter: 16,
      // slidesOffsetBefore: 16,
      breakpoints: {
        768: {
          // spaceBetween: 16,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0
        },
      }
    });
  });
}

if ($('.js-sliderPartnersMultipleRows').length > 0) {
  $(window).on('load', function() {
    let sliderPartnersMultipleRows = new Swiper('.js-sliderPartnersMultipleRows .swiper-container', {
      // spaceBetween: 16,
      // slidesOffsetAfter: 16,
      // slidesOffsetBefore: 16,
      // slidesPerColumnFill: 'row',
      // slidesPerColumn: 2,
      // slidesPerGroup: 1,
      slidesPerView: 'auto',
      breakpoints: {
        768: {
          // spaceBetween: 24,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          followFinger: false,
          // slidesPerColumnFill: 'row',
          // slidesPerColumn: 2,
          // slidesPerGroup: 1,
          // slidesPerView: 'auto',
        },
      }
    });
  });
}